import React, { forwardRef } from 'react';

import { Icon, getThemeColor } from '@rbilabs/components-library';

import { theme } from 'styles/configure-theme';

import { Container, Label } from './clickable-text-with-pencil.styled';
import { IClickableTextWithPencilProps } from './types';

const ClickableTextWithPencil = forwardRef<HTMLButtonElement, IClickableTextWithPencilProps>(
  ({ onClick, label, color = 'icon-default', arialLabel }, ref) => {
    return (
      <Container
        ref={ref}
        data-testid="clickable-text-with-pencil"
        color={getThemeColor(theme, color)}
        onClick={onClick}
        aria-label={arialLabel}
      >
        <Label>{label}</Label>
        <Icon title={label} icon="editWithEraser" width="13px" color={color} />
      </Container>
    );
  }
);

export default ClickableTextWithPencil;
